export function DashboardIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95378 3.3335C4.30944 3.3335 3.78711 3.85583 3.78711 4.50016V8.50016C3.78711 9.1445 4.30944 9.66683 4.95378 9.66683H10.2871C10.9314 9.66683 11.4538 9.1445 11.4538 8.50016V4.50016C11.4538 3.85583 10.9314 3.3335 10.2871 3.3335H4.95378ZM4.78711 4.50016C4.78711 4.40812 4.86173 4.3335 4.95378 4.3335H10.2871C10.3792 4.3335 10.4538 4.40812 10.4538 4.50016V8.50016C10.4538 8.59221 10.3792 8.66683 10.2871 8.66683H4.95378C4.86173 8.66683 4.78711 8.59221 4.78711 8.50016V4.50016Z"
        fill="#00C1C7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4538 4.50016C12.4538 3.85583 12.9761 3.3335 13.6204 3.3335H18.9538C19.5981 3.3335 20.1204 3.85583 20.1204 4.50016V12.5002C20.1204 13.1445 19.5981 13.6668 18.9538 13.6668H13.6204C12.9761 13.6668 12.4538 13.1445 12.4538 12.5002V4.50016ZM13.6204 4.3335C13.5284 4.3335 13.4538 4.40812 13.4538 4.50016V12.5002C13.4538 12.5922 13.5284 12.6668 13.6204 12.6668H18.9538C19.0458 12.6668 19.1204 12.5922 19.1204 12.5002V4.50016C19.1204 4.40812 19.0458 4.3335 18.9538 4.3335H13.6204Z"
        fill="#00C1C7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.95378 11.0002C4.30944 11.0002 3.78711 11.5226 3.78711 12.1669V20.1669C3.78711 20.8112 4.30944 21.3336 4.95378 21.3336H10.2871C10.9314 21.3336 11.4538 20.8112 11.4538 20.1669V12.1669C11.4538 11.5226 10.9314 11.0002 10.2871 11.0002H4.95378ZM4.78711 12.1669C4.78711 12.0749 4.86173 12.0002 4.95378 12.0002H10.2871C10.3792 12.0002 10.4538 12.0749 10.4538 12.1669V20.1669C10.4538 20.259 10.3792 20.3336 10.2871 20.3336H4.95378C4.86173 20.3336 4.78711 20.259 4.78711 20.1669V12.1669Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6204 15.0002C12.9761 15.0002 12.4538 15.5226 12.4538 16.1669V20.1669C12.4538 20.8112 12.9761 21.3336 13.6204 21.3336H18.9538C19.5981 21.3336 20.1204 20.8112 20.1204 20.1669V16.1669C20.1204 15.5226 19.5981 15.0002 18.9538 15.0002H13.6204ZM13.4538 16.1669C13.4538 16.0749 13.5284 16.0002 13.6204 16.0002H18.9538C19.0458 16.0002 19.1204 16.0749 19.1204 16.1669V20.1669C19.1204 20.259 19.0458 20.3336 18.9538 20.3336H13.6204C13.5284 20.3336 13.4538 20.259 13.4538 20.1669V16.1669Z"
        fill="white"
      />
    </svg>
  );
}
